module.exports = __webpack_public_path__ + "img/dosificacion_7.030fb288.png";